import React from 'react';

interface DataSourceAttributionProps {
  isDarkMode?: boolean;
  style?: React.CSSProperties;
}

const DataSourceAttribution: React.FC<DataSourceAttributionProps> = ({
  isDarkMode = false,
  style,
}) => {
  const textColor = isDarkMode ? '#9CA3AF' : '#6B7280';
  const linkColor = isDarkMode ? '#BFDBFE' : '#2563EB';

  return (
    <div
      style={{
        fontFamily: 'Manrope, Arial, sans-serif',
        fontSize: '0.6875rem',
        lineHeight: 1.4,
        color: textColor,
        marginTop: '0.875rem',
        alignSelf: 'flex-start',
        ...style,
      }}
    >
      <span>Data Source: </span>
      <a
        href="https://fiscal.ai"
        target="_blank"
        rel="noreferrer"
        style={{
          color: linkColor,
          textDecoration: 'none',
        }}
      >
        Fiscal.ai
      </a>
    </div>
  );
};

export default DataSourceAttribution;